import { useEffect, useState } from "react";
import { ProductVariant } from "@/routes/pdp/types";
import { ProductSize } from "@/services/productService";

const useActiveSizeTypeSizes = (
  productSizes: ProductSize[],
  activeSizeType: TextAttributeField | EmptyObject = {}
): ProductVariant[] | EmptyObject[] => {
  const getTypeSizes = () =>
    productSizes.find(size => size.sizeType.key === activeSizeType.key)
      ?.variants || [];

  const [typeSizes, setTypeSizes] = useState(getTypeSizes());

  useEffect(() => {
    setTypeSizes(getTypeSizes());
  }, [activeSizeType.key, productSizes]);

  return typeSizes;
};

export default useActiveSizeTypeSizes;
